const escapeCsv = (value) => {
  const string = String(value ?? '');
  return /[",\n]/.test(string) ? `"${string.replace(/"/g, '""')}"` : string;
};

export const buildCsv = (columns, rows) => {
  const header = columns.map((column) => escapeCsv(column.label)).join(',');
  const body = rows.map((row) =>
    columns.map((column) => escapeCsv(row[column.key])).join(',')
  );
  return `\uFEFF${[header, ...body].join('\n')}`;
};

export const downloadCsv = (filename, columns, rows) => {
  const blob = new Blob([buildCsv(columns, rows)], {
    type: 'text/csv;charset=utf-8',
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

export const buildPdfPayload = ({ title, columns, rows, filters }) => ({
  format: 'A4',
  orientation: columns.length > 5 ? 'landscape' : 'portrait',
  title,
  generatedAt: new Date().toISOString(),
  filters,
  columns,
  rows,
});

const escapeHtml = (value) => String(value ?? '')
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;')
  .replace(/'/g, '&#039;');

export const openPrintView = ({ title, columns, rows, filters }) => {
  const printWindow = window.open('', '_blank');
  if (!printWindow) throw new Error('El navegador bloqueó la vista de impresión.');
  const activeFilters = Object.entries(filters || {})
    .filter(([, value]) => value)
    .map(([key, value]) => `<span><strong>${escapeHtml(key)}:</strong> ${escapeHtml(value)}</span>`)
    .join('');
  const headers = columns.map((column) => `<th>${escapeHtml(column.label)}</th>`).join('');
  const body = rows.map((row) => `<tr>${columns
    .map((column) => `<td>${escapeHtml(row[column.key])}</td>`).join('')}</tr>`).join('');

  printWindow.document.write(`<!doctype html><html lang="es"><head><meta charset="utf-8">
    <title>${escapeHtml(title)}</title>
    <style>
      body{font:12px Arial,sans-serif;color:#172033;margin:28px}h1{font-size:20px;margin:0 0 8px}
      .meta{color:#64748b;margin-bottom:18px}.filters{display:flex;gap:12px;flex-wrap:wrap;margin:12px 0}
      table{border-collapse:collapse;width:100%}th,td{border:1px solid #d8dee8;padding:7px;text-align:left}
      th{background:#f1f5f9}.actions{margin-bottom:18px}button{padding:8px 14px;cursor:pointer}
      @media print{.actions{display:none}body{margin:0}}
    </style></head><body><div class="actions"><button onclick="window.print()">Imprimir / guardar PDF</button></div>
    <h1>${escapeHtml(title)}</h1><div class="meta">Generado: ${escapeHtml(new Date().toLocaleString('es-PY'))}</div>
    <div class="filters">${activeFilters}</div><table><thead><tr>${headers}</tr></thead>
    <tbody>${body || `<tr><td colspan="${columns.length}">Sin registros</td></tr>`}</tbody></table></body></html>`);
  printWindow.document.close();
};

export const downloadPdfPayload = (filename, payload) => {
  const blob = new Blob([JSON.stringify(payload, null, 2)], {
    type: 'application/json;charset=utf-8',
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};
